import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/admin/system/')({
  beforeLoad: () => {
    throw redirect({
      to: '/admin/system/rbac',
    })
  },
})
